import { render } from "./ModalCofirm.vue?vue&type=template&id=9c35874c&scoped=true"
import script from "./ModalCofirm.vue?vue&type=script&lang=js"
export * from "./ModalCofirm.vue?vue&type=script&lang=js"

import "./ModalCofirm.vue?vue&type=style&index=0&id=9c35874c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c35874c"]])

export default __exports__